// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3CSaf","row":"ProcedureTreatmentSummary_row__1Yr1X"};